var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.5938,
    r: 28,
    fill: "#425893"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5152 31.3467L35.3087 26.3049H30.4206V23.0277C30.4206 21.6491 31.103 20.302 33.2852 20.302H35.5388V16.0087C34.2264 15.7994 32.9003 15.6862 31.5712 15.6699C27.5481 15.6699 24.9215 18.0884 24.9215 22.4605V26.3049H20.4619V31.3467H24.9215V43.5414H30.4206V31.3467H34.5152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.e4453dd18b950a73d03224651d132625.svg";
export { ForwardRef as ReactComponent };